// extracted by mini-css-extract-plugin
export var byline = "footer-module--byline--3NDX2";
export var credit = "footer-module--credit--kRLVN";
export var fadeIn = "footer-module--fadeIn--cTOzp";
export var footer = "footer-module--footer--lU7l1";
export var footerVisible = "footer-module--footer--visible--SFvVo";
export var footerWrapper = "footer-module--footer-wrapper--ggv+g";
export var lastBuilt = "footer-module--lastBuilt--n7q8U";
export var link = "footer-module--link--svGkA";